import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import { appendFormDataWithObjectValues } from 'utils/appendFormDataWithObjectValues';
import { SportingSecureParams } from 'services/sporting/types';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

type Pyload = {
  idUser: number;
  blocked: boolean;
};

export const setEmployeeBlock = async (
  params: SportingSecureParams<Pyload>
): Promise<void> => {
  const { payload } = params;

  const endpointURL = getSportingServiceURL('setEmployeeBlock');

  const headers = createSportingHeaders();

  const body = new FormData();
  appendFormDataWithObjectValues(body, payload);

  const response = await customFetch(endpointURL, {
    method: 'POST',
    headers,
    body
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
